import React from 'react';
import { bonuses, pricing } from '../data/bonuses';
import { BonusCard } from './BonusCard';
export function Bonuses() {
  return <section id="bonuses" className="bg-charcoal px-4 py-14 md:py-20" data-id="element-30" data-mp="pjg4jxu631zc">
      <div className="mx-auto max-w-3xl text-center" data-id="element-31" data-mp="avv1g3xal2rf">
        <h2 className="font-display text-2xl font-black uppercase leading-tight text-ivory md:text-5xl" data-id="element-32" data-mp="at8w8axvizcd">
          And today, you also get <span className="text-gold" data-id="element-33" data-mp="1tvl7du3q2pj">5 professional bonuses</span>
        </h2>
        <p className="mt-4 font-display text-sm font-extrabold uppercase text-sand md:text-lg" data-id="element-34" data-mp="5w0bq3p96j7y">
          Included at no extra cost.
        </p>
      </div>

      <div className="mx-auto mt-10 grid max-w-6xl gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-35" data-mp="3o2wq7bh7vtk2">
        {bonuses.map(bonus => <BonusCard key={bonus.number} bonus={bonus} data-id="element-36" data-mp="3t2socu38gqrp" />)}
        <div className="flex flex-col items-center justify-center rounded-2xl border-2 border-gold/60 p-6 text-center" data-id="element-37" data-mp="1mbjqr1y0qdve">
          <p className="text-xs font-extrabold uppercase tracking-wider text-ivory/70" data-id="element-38" data-mp="1r8jvn9j4takx">
            Total individual bonus value
          </p>
          <s className="mt-1 font-display text-4xl font-black text-ivory/70 decoration-red-500 decoration-4" data-id="element-39" data-mp="3dflihk627m8a">
            ${pricing.bonusValue} USD
          </s>
          <p className="mt-2 font-display text-lg font-black uppercase text-gold" data-id="element-40" data-mp="3r8ukv0vlb7hb">
            All 5 included free today
          </p>
        </div>
      </div>
    </section>;
}